var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":"","min-width":_vm.minWidth}},'v-btn',attrs,false),on),[_c('v-icon',_vm._g({attrs:{"color":_vm.color,"small":""}},_vm.$listeners),[_vm._t("default")],2)],1)]}}],null,true)},[(_vm.tipkey !== '')?_c('span',[_vm._v(" "+_vm._s(_vm.$t(_vm.tipkey))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }